import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, MapPin, Calendar } from 'lucide-react';
interface BookingCardProps {
  price: string;
  priceDetail?: string;
  duration: string;
  format: string;
}
export function BookingCard({
  price,
  priceDetail,
  duration,
  format
}: BookingCardProps) {
  return <div className="bg-white p-8 rounded-2xl shadow-soft sticky top-32" data-id="element-265" data-mp="239g1word7nd6">
      <h3 className="text-2xl font-serif text-charcoal mb-6 border-b border-cream-200 pb-4" data-id="element-266" data-mp="287r9sty3nnsr">
        Session Details
      </h3>

      <div className="space-y-6 mb-8" data-id="element-267" data-mp="2d5j57xxyds1p">
        <div className="flex items-start" data-id="element-268" data-mp="2d8orl5f76ftq">
          <div className="bg-cream-50 p-3 rounded-full mr-4 text-sage-600" data-id="element-269" data-mp="2i5f6vqj6h7e3">
            <Clock size={20} data-id="element-270" data-mp="2m70fv0sld1j0" />
          </div>
          <div data-id="element-271" data-mp="2m5z6r1v4yp3x">
            <p className="text-sm text-charcoal-50 font-medium mb-1" data-id="element-272" data-mp="2m6h82cwnntip">
              Duration
            </p>
            <p className="text-charcoal" data-id="element-273" data-mp="ntqr5m54h0sn">{duration}</p>
          </div>
        </div>

        <div className="flex items-start" data-id="element-274" data-mp="rtj1a3a5zf04">
          <div className="bg-cream-50 p-3 rounded-full mr-4 text-sage-600" data-id="element-275" data-mp="2dp8komrdd7q7">
            <MapPin size={20} data-id="element-276" data-mp="2drbk1xeewd7l" />
          </div>
          <div data-id="element-277" data-mp="28xqu8smz2pjh">
            <p className="text-sm text-charcoal-50 font-medium mb-1" data-id="element-278" data-mp="28y0bnrtybodk">Format</p>
            <p className="text-charcoal" data-id="element-279" data-mp="23yvy6ozzv4hf">{format}</p>
          </div>
        </div>

        <div className="flex items-start" data-id="element-280" data-mp="1z149e3unbyhg">
          <div className="bg-cream-50 p-3 rounded-full mr-4 text-sage-600" data-id="element-281" data-mp="1z25n6g31qz2v">
            <Calendar size={20} data-id="element-282" data-mp="2wnbf5h2orwve" />
          </div>
          <div data-id="element-283" data-mp="2wm09fbpokf1n">
            <p className="text-sm text-charcoal-50 font-medium mb-1" data-id="element-284" data-mp="2rpjb5oorokau">
              Investment
            </p>
            <p className="text-charcoal font-medium" data-id="element-285" data-mp="2mpngig1ym57y">{price}</p>
            {priceDetail && <p className="text-charcoal-50 text-sm font-light mt-1 leading-relaxed" data-id="element-286" data-mp="2hrlmx16wqni8">
                {priceDetail}
              </p>}
          </div>
        </div>
      </div>

      <div className="space-y-4" data-id="element-287" data-mp="16c6ri1uck3p8">
        <Link to="/lets-connect" className="block w-full bg-sage text-white text-center py-3 rounded-full tracking-wide hover:bg-sage-600 transition-colors" data-id="element-288" data-mp="16avmjyp60pwj">
          Join a Session
        </Link>
        <Link to="/lets-connect" className="block w-full border border-charcoal-50 text-charcoal-50 text-center py-3 rounded-full tracking-wide hover:bg-charcoal-50 hover:text-white transition-colors" data-id="element-289" data-mp="2da3q00sqlpt">
          Ask a Question
        </Link>
      </div>
    </div>;
}